import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import * as Tools from "../../helpers/Tools";
import * as msgs from "../../constants/textConstants";
import { logUI } from "../../api/andyliticsApi";
import { Typography, Button, Icon, Divider, Grid } from "../ecosystem/";
import { InHomeMainPanel, InHomeOverviewPanel, InHomePatientInputSection, InHomeSplitLayout } from "./layout"


const InHomeNudge = ({ history, screenBreakPoint }) => {

    const onClickNo = () => {
        logUI(`MBHWeb.UI.InHomeSchedulingNudge.No Thank you.Clicked`, new Date(), Tools.getURLPath());
        history.push("/inhomeschedule/s5")
    }
    const onClickYes = () => {
        logUI(`MBHWeb.UI.InHomeSchedulingNudge.Yes I would.Clicked`, new Date(), Tools.getURLPath());
        history.push({ pathname: "/inhomeschedule/s4", yesAddVaccineClicked: true });
    }

    const isMobileSize = (screenBreakPoint === msgs.XS_MOBILE || screenBreakPoint === msgs.SM_MOBILE) ? true : false;

    return (
        <>
            <InHomeSplitLayout
                className="inhome-nudge"
                progressPercent={4 / 7 * 100}
            >
                <InHomeMainPanel
                    centerSchedulingQuestions={true}
                >
                    <div className="row">
                        <div className="col-12 scheduling-wrapper">
                            <div className="nudge-detail-wrapper">
                                <div className="ihome-nudge-icon-wrapper">
                                    <Icon name="information" set="brand" size="large" />
                                </div>
                                <div className="nudge-label-head">
                                    <Typography
                                        type={isMobileSize ? "heading-03" : "heading-06"}
                                    >
                                        Did you know?
                                    </Typography>
                                </div>
                                <div className="nudge-label-content">
                                    <Typography
                                        color={"$color-secondary-a2"}
                                        type={isMobileSize ? "body-02" : "heading-02"}
                                    >
                                        Getting multiple vaccines at the same time is both the safest and the most effective method to prevent disease and serious illness.
                                    </Typography>
                                </div>
                                <div className="nudge-divider">
                                    <Divider mTop="small" mBottom="none" mLeft="none" mRight="none" />
                                </div>
                                <div className="inhome-nudge-wrapper">
                                    <div className="nudge-label-subcontent">
                                        <Typography
                                            type={isMobileSize ? "body-03" : "body-02"}
                                            textAlign={isMobileSize ? "center" : "left"}
                                            bold={isMobileSize}
                                            tag="div"
                                        >
                                            Would you like to add any other vaccines to this appointment?
                                        </Typography>
                                    </div>
                                    <div className="inhome-nudge-buttons">
                                        <div className="nudge-yes-button">
                                            <Button
                                                fluid
                                                onClick={onClickYes}
                                            >
                                                Yes, add more vaccines
                                            </Button>
                                        </div>
                                        <div className="nudge-no-button">
                                            <Button
                                                fluid
                                                variant="secondary"
                                                onClick={onClickNo}
                                            >
                                                No, thanks
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </InHomeMainPanel>

                <InHomeOverviewPanel vaccinesPhase={true} />
            </InHomeSplitLayout>
        </>
    );
}

const mapStateToProps = state => {
    return {
        screenBreakPoint: state.common.screenBreakPoint,
    }
}

export default connect(mapStateToProps)(InHomeNudge);